import React, { useState } from 'react';
import { projelerData } from '../data/projeler-data';
import { Link, useParams } from 'react-router-dom';
import LinkComponent from '../components/LinkComponent';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

import { azxc, bzxc, fadeInUp, variants } from '../script/animationVariants';

const ProjelerInner = () => {
    const { id1 } = useParams();
    const { i18n } = useTranslation();
    const currentLanguage = i18n.language; // Mevcut dili alıyoruz

    const [hoveredIndex, setHoveredIndex] = useState(null);
    const category = projelerData.find(category => category.link === id1);

    if (!category) return <div>Category not found</div>;

    return (
        <div className='flex flex-col'>
            <LinkComponent />
            <div className='grid grid-cols-14 bg-white'>
                <div className='col-start-2 col-span-11'>
                    <motion.div
                        variants={fadeInUp(0.2)}
                        initial="initial"
                        whileInView="animate"
                        className='mb-10 font-extralight text-2xl'
                    >
                        {category.title[currentLanguage]}
                    </motion.div>
                </div>
            </div>

            <div className='w-full bg-white grid grid-cols-14 customHScreen'>
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    variants={azxc}
                    className='col-start-2 col-span-12 grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4 gap-2'
                >
                    {category.categoryItem.map((item, index) => {
                        const isHovered = hoveredIndex !== null && hoveredIndex !== index;

                        return (
                            <Link to={`/projeler/${id1}/${item.link}`} key={index}>
                                <motion.div
                                    variants={bzxc}
                                    className="relative !aspect-square group cursor-pointer "
                                    onMouseEnter={() => setHoveredIndex(index)}
                                    onMouseLeave={() => setHoveredIndex(null)}
                                >
                                    <div className="absolute top-0 left-0 h-full w-full overflow-hidden">
                                        <img
                                            src={`/images/projeler/${id1}/${item.link}/1.jpg`}
                                            className="h-full w-full object-cover duration-300 group-hover:scale-105"
                                            alt={item.title[currentLanguage]}
                                        />
                                                  <img 
                                        src='/images/filigran-square.png' 
                                        className='absolute top-0 left-0 w-full h-full object-cover pointer-events-none' 
                                        alt=""
                                    />
                                    </div>

                                    <div className={`absolute top-0 left-0 h-full w-full transition-opacity bg-black duration-300 ${isHovered ? 'opacity-60' : 'opacity-30'}`}></div>
                                    <div className="absolute h-full w-full flex justify-end items-start p-5 opacity-0 group-hover:opacity-100 duration-300">
                                        <img src='/images/icons/arrow-white.svg' className='w-1/6' alt="arrow" />
                                    </div>
                                    <div className='h-full w-full relative z-10 p-10 flex flex-col justify-between'>
                                        <div></div>
                                        <div>
                                            <h2 className="text-white text-base opacity-0 group-hover:opacity-100 transition-all duration-300">
                                                {item.title[currentLanguage]}
                                            </h2>
                                        </div>
                                    </div>
                                </motion.div>
                            </Link>
                        );
                    })}
                </motion.div>
            </div>
        </div>
    );
};

export default ProjelerInner;
